'use strict';

import { loadComponent } from './utils/load-component';
import { getPackage } from '../services/package';
import { initialiseElement as initScroller } from '../modules/scroller';
import { getEventData } from '../services/inventory';

loadComponent('package-scroller', {
    props: {
        packageNo: {
            Type: Number,
        },
    },

    data() {
        return {
            ViewModel: {
                Loading: true,
                PackageLink: null,
                SubscriptionLink: null,
                Events: [],
            },
        }
    },

    beforeMount() {
        Promise.all([ getPackage(this.packageNo), getEventData() ]).then(responses => {
            const [ packageResponse, eventsResponse ] = responses;

            if (packageResponse) {
                this.ViewModel.PackageLink = packageResponse.PackageLink;

                this.ViewModel.SubscriptionLink = packageResponse.TicketLink;

                this.ViewModel.Events = eventsResponse.filter(event => {
                    return packageResponse.Performances.some(details => {
                        return parseInt(details.Id, 10) === parseInt(event.PerformanceNumber, 10);
                    });
                });
            }
        }).finally(() => {
            this.ViewModel.Loading = false;

            this.$nextTick(() => {
                if (this.$refs.scroller) {
                    initScroller(this.$refs.scroller);
                }
            });
        });

        // if (!this.packageNo) {
        //     throw 'Missing Package No';
        // }

        // Promise.all([getPackage(this.packageNo), getEventData()])
        //     .then(([packages, events]) => {
        //         const foundEvents = events.filter(event => {
        //             return packages.performances.some(details => {
        //                 return details.some(
        //                     performance =>
        //                         performance.id === event.PerformanceNumber
        //                 );
        //             });
        //         });

        //         this.ViewModel.Events = foundEvents.filter(perf => {
        //             perf.Date = format(zonedDate(perf.PerformanceDate), 'MMM dd, yyyy');
        //             return perf;
        //         });
        //     })
        //     .finally(() => {
        //         this.ViewModel.Loading = false;
        //         this.$nextTick(() => {
        //             initScroller(this.$el);
        //         });
        //     });
    }
});
